import useProjectStore from '../../stores/projectStore';

/**
 * Kleines Badge, das pro Page anzeigt, in welchem Projektkontext man arbeitet.
 * Wird oberhalb des Page-Titels gerendert, damit der Scope sofort klar ist.
 */
export default function ProjectContextBadge() {
  const project = useProjectStore((s) => s.projects.find((p) => p.id === s.currentProjectId));

  if (!project) return null;

  return (
    <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-white border border-black/[.07] mb-2 shadow-sm">
      <div
        className="w-4 h-4 rounded flex items-center justify-center text-[8px] font-bold text-white"
        style={{ backgroundColor: project.color || '#0C9488' }}
      >
        {(project.name || '?')[0]?.toUpperCase()}
      </div>
      <div className="text-[11px] font-medium text-gray-700">{project.name}</div>
      {project.domain && (
        <div className="text-[10.5px] text-gray-400 font-mono">· {project.domain}</div>
      )}
    </div>
  );
}
